// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { MapScriptStage, MapScriptStageT } from '../tbs/map-script-stage.js';


export class MapScriptFormData implements flatbuffers.IUnpackableObject<MapScriptFormDataT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MapScriptFormData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMapScriptFormData(bb:flatbuffers.ByteBuffer, obj?:MapScriptFormData):MapScriptFormData {
  return (obj || new MapScriptFormData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMapScriptFormData(bb:flatbuffers.ByteBuffer, obj?:MapScriptFormData):MapScriptFormData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MapScriptFormData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

seed():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

stages(index: number, obj?:MapScriptStage):MapScriptStage|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new MapScriptStage()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

stagesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startMapScriptFormData(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addSeed(builder:flatbuffers.Builder, seed:number) {
  builder.addFieldInt32(0, seed, -1);
}

static addStages(builder:flatbuffers.Builder, stagesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, stagesOffset, 0);
}

static createStagesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startStagesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endMapScriptFormData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createMapScriptFormData(builder:flatbuffers.Builder, seed:number, stagesOffset:flatbuffers.Offset):flatbuffers.Offset {
  MapScriptFormData.startMapScriptFormData(builder);
  MapScriptFormData.addSeed(builder, seed);
  MapScriptFormData.addStages(builder, stagesOffset);
  return MapScriptFormData.endMapScriptFormData(builder);
}

unpack(): MapScriptFormDataT {
  return new MapScriptFormDataT(
    this.seed(),
    this.bb!.createObjList<MapScriptStage, MapScriptStageT>(this.stages.bind(this), this.stagesLength())
  );
}


unpackTo(_o: MapScriptFormDataT): void {
  _o.seed = this.seed();
  _o.stages = this.bb!.createObjList<MapScriptStage, MapScriptStageT>(this.stages.bind(this), this.stagesLength());
}
}

export class MapScriptFormDataT implements flatbuffers.IGeneratedObject {
constructor(
  public seed: number = -1,
  public stages: (MapScriptStageT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const stages = MapScriptFormData.createStagesVector(builder, builder.createObjectOffsetList(this.stages));

  return MapScriptFormData.createMapScriptFormData(builder,
    this.seed,
    stages
  );
}
}
